// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__GAt6S","location":"Header_location__Hl2KM"};